module.exports = __webpack_public_path__ + "resources/icon-star-blue.a23932029493b685.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/avatar/img/icon-star-blue.png
// module id = 412
// module chunks = 0 1 2 3 4